import { ComponentPropsWithoutRef, FC } from 'react';

interface IProps extends ComponentPropsWithoutRef<'h6'> {
  text: string;
  isPrimary?: boolean;
}

const Title: FC<IProps> = ({ isPrimary = false, text, className = '', ...props }) => {
  return (
    <h6 className={`text-hl-black font-bold ${isPrimary ? 'text-2xl sm:text-5xl' : 'text-xl sm:text-3xl'} ${className}`} {...props}>
      {text}
    </h6>
  );
};

export default Title;
